import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import {
  BasicButtonColors,
  BasicButtonModes,
  BasicButtonSizes,
  BasicButtonTooltipPosition,
} from '@app/shared/enums/buttons';
import { UtilService } from '@app/shared/services/utils/util.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cm-basic-button',
  templateUrl: './basic-button.component.html',
  styleUrls: ['./basic-button.component.scss', '../../../../styles/base/_typography.scss'],
})
export class BasicButtonComponent implements OnInit {
  @Input() label?: string;
  @Input() color?: BasicButtonColors = BasicButtonColors.PRIMARY;
  @Input() size?: BasicButtonSizes = BasicButtonSizes.MEDIUM;
  @Input() mode?: BasicButtonModes = BasicButtonModes.FILLED;
  @Input() tooltipPosition: BasicButtonTooltipPosition = BasicButtonTooltipPosition.ABOVE;
  @Input() shadow: boolean;
  @Input() disabled: boolean;
  @Input() isWashed: boolean;
  @Input() tooltipClass: string = null;
  @Input() tooltipMessage: string = null;
  @Input() dataCy: string;

  @Input() isDataGridHeaderAction = false;
  @Input() mobileActionIconName: string;
  public isPhoneSize = UtilService.isPhoneSize();

  @Output() clickEvent = new EventEmitter<boolean>();

  @HostListener('window:resize', [])
  public onResize(): void {
    this.isPhoneSize = UtilService.isPhoneSize();
  }
  constructor(protected ts: TranslateService) {}

  ngOnInit(): void {
    this.tooltipMessage = this.tooltipMessage && this.ts.instant(this.tooltipMessage);
    this.shadow = this.shadow || this.mode === BasicButtonModes.FILLED;
  }

  handleClick() {
    !this.disabled && this.clickEvent.emit(true);
  }
}
